import { render, staticRenderFns } from "./nbn-order-attachments.vue?vue&type=template&id=3b735419&scoped=true"
import script from "./nbn-order-attachments.vue?vue&type=script&lang=js"
export * from "./nbn-order-attachments.vue?vue&type=script&lang=js"
import style0 from "./nbn-order-attachments.vue?vue&type=style&index=0&id=3b735419&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b735419",
  null
  
)

export default component.exports